const API_URL: string = process.env.REACT_APP_API_URI
	? process.env.REACT_APP_API_URI
	: "";

export { API_URL };
